import React, { useState, useEffect, useRef } from 'react';
import apiHelpers from '../../utils/apiHelpers';

const CardImage = props => {
  const [cardImage, setCardImage] = useState('/img/placeholder.webp');
  const [cardURL, setCardURL] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    if (!isVisible) return;

    if (props.card.imageUrl) {
      setCardImage(props.card.imageUrl);
      setCardURL(props.card.cardUrl);
      return;
    }

    const currCardName = props.card.name;
    setTimeout(() => {
      if (!props.card.imageUrl && currCardName === props.card.name) {
        apiHelpers.getCardByName(props.card.name).then(result => {
          if (result.data && result.data[0] && result.data[0].imageUrl) {
            setCardImage(result.data[0].imageUrl);
          }
          if (result.data && result.data[0] && result.data.cardUrl) {
            setCardURL(result.data[0].cardUrl);
          }
        });
      }
    }, 1000);
  }, [props.card, isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '1000px', // Preload when the element is 1000px from being in view
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      },
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  return (
    <a href={cardURL} target="_blank" rel="noopener noreferrer" ref={imageRef}>
      <img
        className="bg-transparent rounded-[16px]"
        src={cardImage ? cardImage : '/img/placeholder.webp'}
        alt={props.card.name}
      />
    </a>
  );
};

export default CardImage;
